module.exports = __webpack_public_path__ + "img/s-bg-2.922ebca6.png";